<script setup lang="ts"></script>

<template>
  <div class="login-page__footer">
    <slot />
  </div>
</template>

<style scoped>
  .login-page__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    margin-top: auto;
    background-color: #ffffff;
    border-radius: 16px 16px 0 0;
    padding: 24px 16px;
  }
</style>